import { AfterContentInit, AfterViewInit, ApplicationRef, ChangeDetectorRef, Component, Directive, DoCheck, EventEmitter, HostListener, Injectable, Input, NgModule, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { Location, LocationStrategy } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import { Http, Headers, RequestOptions } from '@angular/http';
import { ActivatedRoute, CanDeactivate, Params, Router, RouterModule, Routes } from '@angular/router';
import { DomSanitizer, SafeUrl, SafeHtml } from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';
import { tap, merge } from 'rxjs/operators';

export {
  ActivatedRoute,
  AfterContentInit,
  AfterViewInit,
  ApplicationRef,
  CanDeactivate,
  ChangeDetectorRef,
  Component,
  Directive,
  DoCheck,
  DomSanitizer,
  EventEmitter,
  Headers,
  HostListener,
  Http,
  Injectable,
  Input,
  Location,
  LocationStrategy,
  NgForm,
  NgModule,
  Observable,
  OnChanges,
  OnInit,
  Output,
  Params,
  RequestOptions,
  Router,
  RouterModule,
  Routes,
  SafeHtml,
  SafeUrl,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
  tap,
  merge,
  HttpClient
};



// WEBPACK FOOTER //
// ./src/app/ng.ts